import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { Heading, Modal } from '@zillow/constellation-10';

import { PaymentGatewayContext } from '../../PaymentGateway/context';
import { default as pgActions } from '../../PaymentGateway/actions';

import { DISPLAY_CONTEXT } from '../../PaymentGateway/constants';

import PremiumFeatureSummary from '../../PremiumFeatureSummary';

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onOpen: PropTypes.func,
  onOptionSelected: PropTypes.func,
  updateDisplayPaymentOptionsModal: PropTypes.func.isRequired,
};

const defaultProps = {
  onOpen: () => {},
  onOptionSelected: () => {},
};

const PaymentOptionsModal = ({ isOpen, updateDisplayPaymentOptionsModal, onOpen, onOptionSelected }) => {
  const { reducerDispatch: pgReducerDispatch } = useContext(PaymentGatewayContext);

  useEffect(() => {
    if (isOpen) {
      // eslint-disable-next-line no-use-before-define
      updatePGDisplayContext(DISPLAY_CONTEXT.POSTING_PATH);
      onOpen();
    }

    // EXCEPTION
    // DO NOT reset updatePGDisplayContext to be null on close
  }, [isOpen]);

  /**
   * Control payment gateway display context here.
   *
   * This component is only used in the posting path.
   *
   * We should be controlling this at the moment of updating the payment gateway display
   */
  const updatePGDisplayContext = (displayContext) => {
    pgActions.updateDisplayContext({
      reducerDispatch: pgReducerDispatch,
      displayContext,
    });
  };

  const handleOptionSelected = (type) => {
    // trigger callback
    onOptionSelected(type);

    updateDisplayPaymentOptionsModal(false);
  };

  return (
    <Modal
      open={isOpen}
      header={<Heading level={2}>Posting options</Heading>}
      body={
        <PremiumFeatureSummary
          backgroundColor="backgroundWhite"
          componentContext={DISPLAY_CONTEXT.POSTING_PATH}
          displayContentFullWidth={true}
          hideCompareAndLearnMore={true}
          offsetPageWizardTopMargin={false}
          paddingTop="sm"
          onPublishClick={handleOptionSelected}
        />
      }
      size={{ base: 'fullScreen', md: 'md' }}
      useDismissProps={{ outsidePress: false }}
      onOpenChange={(open) => !open && updateDisplayPaymentOptionsModal(false)}
    />
  );
};

PaymentOptionsModal.propTypes = propTypes;
PaymentOptionsModal.defaultProps = defaultProps;

export default PaymentOptionsModal;
